import { render } from "./ViewCampaignDiscountModal.vue?vue&type=template&id=41bf1c08&scoped=true"
import script from "./ViewCampaignDiscountModal.vue?vue&type=script&lang=js"
export * from "./ViewCampaignDiscountModal.vue?vue&type=script&lang=js"

import "./ViewCampaignDiscountModal.vue?vue&type=style&index=0&id=41bf1c08&lang=scss&scoped=true"

import exportComponent from "/builds/retina-v5/principal-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41bf1c08"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection});
